import { Button, styled } from '@mui/material';
import Menu from '@mui/material/Menu';
import { saasModernTheme } from 'common/theme/saasModern';
import MenuItem from '@mui/material/MenuItem';
import Link from 'next/link';

export const SubMenuButton = styled(Button)(({ theme, active }) => ({
  backgroundColor: active
    ? saasModernTheme.defaultBackgroundColor
    : 'transparent',
  '&:hover': {
    backgroundColor: active
      ? saasModernTheme.defaultBackgroundColor
      : theme.palette.action.hover,
  },
  position: 'relative',
  color: active ? 'white' : 'black',
  textTransform: 'capitalize',
  fontFamily: saasModernTheme.fontFamily,
  padding: theme.spacing(2),
  borderRadius: '8px',
  fontSize: '16px',
  fontStyle: 'normal',
  lineHeight: 'normal',
  fontWeight: 700,
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    backgroundColor: saasModernTheme.colors.white,
    borderRadius: '8px',
    boxShadow: saasModernTheme.gradiantShadow,
    padding: theme.spacing(3),
    color: theme.palette.common.white,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme, active }) => ({
  backgroundColor: active
    ? saasModernTheme.defaultBackgroundColor
    : 'transparent',
  borderRadius: '4px',
  margin: '2px 0',
}));

export const StyledLink = styled(Link)(({ theme, active }) => ({
  display: 'block',
  textDecoration: 'none',
  flex: 1,
  color: active ? 'white' : theme.palette.common.black,
  fontFamily: saasModernTheme.fontFamily,
  fontSize: '16px',
  width: '100%',
  padding: theme.spacing(1),
}));

export const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  color: '#5F6368',
  '& svg': {
    width: '20px',
    height: '20px',
  },
}));
